import {Chip} from "@mui/material";
import List from "@mui/material/List";
import Paper from "@mui/material/Paper";
import {styled} from "@mui/material/styles";
import Typography from "@mui/material/Typography";

const ListItem = styled('li')(({theme}) => ({
    margin: theme.spacing(0.5),
}));

/**
 * Helper to create the array of chips
 * @param busesOff
 * @returns {*}
 * @constructor
 */
const GeneratorOffBuses = ({busesOff = []}) => {
    return busesOff.map(([meters, id, {data}], i) => {
        return (
            <ListItem key={i}>
                <Chip label={data["unit_number"]}/>
            </ListItem>
        );
    });
}

/**
 * Helper component to show a Paper with the saved spaces
 * @param busesOff
 * @returns {JSX.Element}
 * @constructor
 */
export const OffServiceBuses = ({busesOff = []}) => {

    return (
        <>
            <Typography variant={"h6"}>Unidades en pensión: {busesOff.length}</Typography>
            <List dense={false}>
                <Paper
                    sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        flexWrap: 'wrap',
                        listStyle: 'none',
                        p: 0.5,
                        m: 0,
                    }}
                    component="ul"
                >
                    {busesOff && <GeneratorOffBuses busesOff={busesOff}/>}
                </Paper>
            </List>
        </>
    )
}